import React, { useEffect, useRef, useState } from 'react';
import './TechStack.css';

const TechStack = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1, rootMargin: isMobile ? '0px' : '-150px' }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const technologies = [
    { name: 'Python', logo: '/photo/logo_entreprise/python.png' },
    { name: 'Node.js', logo: '/photo/logo_entreprise/nodejs.png' },
    { name: 'OpenAI', logo: '/photo/logo_entreprise/OpenAI.png' },
    { name: 'Gemini', logo: '/photo/logo_entreprise/gemini.png' },
    { name: 'Mistral', logo: '/photo/logo_entreprise/Mistral.png' },
    { name: 'Hugging Face', logo: '/photo/logo_entreprise/hugging_face.png' },
    { name: 'LangChain', logo: '/photo/logo_entreprise/langchain.webp' },
    { name: 'LangGraph', logo: '/photo/logo_entreprise/langgraph-color.png' },
    { name: 'PyTorch', logo: '/photo/logo_entreprise/pytorch.png' }
  ];

  return (
    <section className={`tech-stack ${isVisible ? 'visible' : ''}`} ref={sectionRef}>
      <div className="tech-stack-container">
        <h2 className="tech-stack-title">
          Mon <span className="highlight-stack">stack technique</span>
        </h2>
        <div className="tech-stack-grid">
          {technologies.map((tech, index) => (
            <div 
              key={index}
              className={`tech-item fade-in-up delay-${(index % 3 + 1) * 100} ${isVisible ? 'visible' : ''}`}
            >
              <img src={tech.logo} alt={tech.name} className="tech-logo" />
              <span className="tech-name">{tech.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStack;